import React, { useState, useEffect } from 'react';
import newsletterService from './NewsletterService';
import { Container, Row, Col, Card, CardBody, CardTitle, CardText, ListGroup, ListGroupItem, Badge, Spinner, Button, CardHeader } from 'reactstrap';

function stripHtml(html) {
	if (!html) return '';
	return html.replace(/<[^>]*>/g, '').replace(/\s+/g, ' ').trim();
}

function enhanceImages(html) {
	if (!html) return html;
	// Add responsive image style to any <img> tags that don't already have a style attribute
	try {
		return html.replace(/<img(?![^>]*style=)([^>]*)>/gi, '<img style="max-width:100%;height:auto;display:block;"$1>');
	}
	catch (e) {
		return html;
	}
}

export function NewsletterPage() {
	const [loading, setLoading] = useState(true);
	const [current, setCurrent] = useState(null);
	const [previous, setPrevious] = useState([]);
	const [expandedId, setExpandedId] = useState(null);

	useEffect(() => {
		let mounted = true;
		async function load() {
			try {
				// request a reasonably large page to get recent newsletters
				const data = await newsletterService.getData(1, 100, 'senddate_desc', '');
				const items = (data && data.entities) ? data.entities.map(e => ({ ...e })) : [];

				if (!mounted) return;

				// parse sendDate for sorting/comparison
				items.forEach(i => {
					if (i.sendDate) i._sendDate = new Date(i.sendDate);
					else i._sendDate = new Date(0);
				});

				// Only consider enabled newsletters for display
				const enabledItems = items.filter(i => i.enabled);

				// find current: prefer enabled newsletter with sendDate <= today, most recent first
				const now = new Date();
				let currentItem = enabledItems.find(i => i._sendDate <= now);
				if (!currentItem && enabledItems.length > 0) {
					// fallback: most recent enabled
					currentItem = enabledItems[0];
				}

				const prev = enabledItems.filter(i => !currentItem || i.id !== currentItem.id);

				setCurrent(currentItem);
				setPrevious(prev);
			}
			catch (err) {
				console.error(err);
			}
			finally {
				if (mounted) setLoading(false);
			}
		}

		load();
		return () => { mounted = false; };
	}, []);

	if (loading) return (
		<Container className="mt-4">
			<Row>
				<Col className="text-center"><Spinner /> Loading newsletters...</Col>
			</Row>
		</Container>
	);

	return (
		<Container className="mt-4">

			<Row className="mt-3">
				<Col md={8}>
					{current ? (
						<Card>
							<CardHeader>
								<CardTitle tag="h3">{current.name}</CardTitle>
								<div className="text-muted mb-2">{current.sendDate ? new Date(current.sendDate).toLocaleDateString() : ''} </div></CardHeader>
							<CardBody>
								
								<CardText>
									{/* Inject responsive image styles into content before rendering */}
									<div dangerouslySetInnerHTML={{ __html: enhanceImages(current.content || '<em>No content</em>') }} />
								</CardText>
							</CardBody>
						</Card>
					) : (
						<Card>
							<CardBody>
								<CardTitle tag="h3">No current newsletter</CardTitle>
								<CardText>No newsletters are available at this time.</CardText>
							</CardBody>
						</Card>
					)}
				</Col>

				<Col md={4}>
					<Card>
						<CardHeader>
							<CardTitle tag="h5">Previous editions</CardTitle>
						</CardHeader>
						<CardBody>
							<ListGroup flush>
								{previous && previous.length > 0 ? previous.map(item => (
									<ListGroupItem key={item.id}>
										<div className="d-flex justify-content-between align-items-center">
											<div>
												<strong>{item.name}</strong><br />
												<small className="text-muted">{item.sendDate ? new Date(item.sendDate).toLocaleDateString() : ''}</small>
											</div>
											<div>
												<Button color="link" onClick={() => setExpandedId(expandedId === item.id ? null : item.id)}>
												{expandedId === item.id ? 'Hide' : 'Show'}
											</Button>
											</div>
										</div>
										{expandedId === item.id && (
											<div className="mt-2" style={{ maxHeight: '200px', overflowY: 'auto' }}>
												{/* Inject responsive image styles into preview content */}
												<div dangerouslySetInnerHTML={{ __html: enhanceImages(item.content || '') }} />
											</div>
										)}
									</ListGroupItem>
								)) : (
									<ListGroupItem>No previous newsletters</ListGroupItem>
								)}
							</ListGroup>
						</CardBody>
					</Card>
				</Col>
			</Row>
		</Container>
	);
}
//const NewsletterPage = withTranslation()(withRouter(NewsletterPagePlain));
 
